import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { customTheme, shadowStyle } from '../../util/util'

export const styles = {
  mainContainer: {
    alignSelf: 'center',
    pt: 24,
    pb: 16,
    ...shadowStyle,
    borderRadius: 4,
    bg: 'WHITE',
  } as BoxProps,
  separator: {
    h: 1,
    width: '100%',
    bg: 'SEPERATOR',
  } as BoxProps,
  cancelButton: (bgColor: ColorOptions) =>
    ({
      ph: 10,
      h: 30,
      justify: 'center',
      bg: bgColor ?? 'WHITE',
      ...shadowStyle,
      borderRadius: 4,
      underlayColor: 'LIGHTEST_GREY',
    } as BoxProps),
  textContainer: {
    justifyContent: 'center',
  } as BoxProps,
  title: {
    fontSize: 16,
    fontFamily: 'jiotype-medium',
    lineHeight: 24,
    color: 'BLACK_21',
  } as TextNewProps,
  textIconCont: {
    flexDirection: 'row',
    pv: 2,
  } as BoxProps,
  iconTitleText: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'jiotype-medium',
    color: 'PRIMARY_GREY' as ColorOptions,
  } as TextNewProps,
  itemContainer: {
    mt: 15,
    borderLeftWidth: 2,
    pl: 10,
    borderLeftColor: customTheme.colors.ERROR_RED,
  } as BoxProps,
  subContainer: {
    ph: 24,
  } as BoxProps,
  btnContainer: {
    flexDirection: 'row',
    alignSelf: 'flex-end',
    pt: 16,
    ph: 16,
  } as BoxProps,
  activityIndicator: {
    width: 90,
  },
}
